import { NavLink, Link } from 'react-router-dom';

const menuItems = [
  { name: 'home', label: 'Home', path: '/' },
  { name: 'promo', label: 'Promo', path: '/promo' },
];

const Navbar = () => {
  return (
    <header className="fixed bg-sky-400 text-white py-2 px-[10px] md:px-[50px] lg:px-[70px] xl:px-[100px] w-full z-10">
      <div className="flex justify-between">
        <div className="">
          <Link to="/"><img src={`${process.env.PUBLIC_URL}/media/images/logo-familymart.png`} className='w-[175px] md:w-[260px]' alt='FamilyMart Indonesia' /></Link>
        </div>
        <div className="content-center">
          <div className="flex gap-2 md:gap-8">
            {menuItems.map((item) => (
              <NavLink key={item.name} to={item.path} className={({ isActive }) =>
                `flex w-full items-center justify-center rounded-lg py-2 px-4 lg:px-12 text-sm md:text-base ${isActive ? 'bg-blue-primary' : ''
                }`
              }>{item.label}</NavLink>
            ))}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;